import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { RadioGroupItemLabelProps } from './RadioGroupItemLabel.interfaces';

const RadioGroupItemLabel = ({ title, description }: RadioGroupItemLabelProps) => {
  const { translate } = useTranslation();

  return (
    <Stack sx={{ gap: 0.5 }}>
      <Typography>{translate(title)}</Typography>
      <Typography variant="body2" color="text.secondary">
        {translate(description)}
      </Typography>
    </Stack>
  );
};

export default RadioGroupItemLabel;
